import React from 'react';

const Pagination = ({ currentPage, totalPages, setCurrentPage }: { currentPage: number; totalPages: number; setCurrentPage: (page: number) => void }) => (
    <div className='flex items-center justify-between p-4 border-t border-blue-gray-50'>
        <p className='block font-sans text-sm antialiased font-normal leading-normal text-blue-gray-900'>
            Pagina {currentPage} van {totalPages || 1}
        </p>
        <div className='flex gap-2'>
            <button
                className='select-none rounded-lg border border-gray-900 py-2 px-4 text-center align-middle font-sans text-xs font-bold uppercase text-gray-900 transition-all hover:opacity-75 focus:ring focus:ring-gray-300 active:opacity-[0.85] disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none'
                type='button'
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}>
                Vorige
            </button>
            <button
                className='select-none rounded-lg border border-gray-900 py-2 px-4 text-center align-middle font-sans text-xs font-bold uppercase text-gray-900 transition-all hover:opacity-75 focus:ring focus:ring-gray-300 active:opacity-[0.85] disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none'
                type='button'
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}>
                Volgende
            </button>
        </div>
    </div>
);

export default Pagination;